import videojs from 'video.js';

class ThinAndAlign extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        super(player, options);
        player.addClass('vjs-thin-and-align');
    }
}

videojs.registerPlugin('thinAndAlign', ThinAndAlign);
